import React, { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";

import { FaFileExcel, FaFilter } from "react-icons/fa";

import { downloaditPost } from "../../utils/download";
import { apiUrl } from "../../config";

interface IData {
    value: number;
    name: string;
    simpleName?: string;
    percentage?: string;
}

interface IChart {
    title?: string;
    subtitle?: string;
    data: Array<Record<string, any>>;
    category?: string;
    group?: string;

}

interface IConverter {
    data: IData[];
    type: string;
    title: string;
}

const Chart: React.FC<IChart> = ({ category = '', group = '', data = [], title = '', subtitle = '' }) => {

    const [renderData, setRenderData] = useState<IData[]>([])
    const [groupColumn, setGroupColumn] = useState(group);
    const [type, setType] = useState('pie');

    const convertToArrayAndExport = ({ data, type = 'xlsx', title }: IConverter) => {

        const content = [[title, 'Quantidade', 'Porcentagem']];

        data.map(item => {
            content.push([item.simpleName || '', item?.value?.toString() || '0', item?.percentage?.toString()?.replace('.', ',') || '0'])
        })



        return downloaditPost({ url: `${apiUrl}/converter/${type}`, data: content, type });

    }


    const changeGroup = (value: string) => {
        setGroupColumn(value);
    }

    const renderDataInfo = async (groupInfo: string, dataContent) => {


        const dataInfo = dataContent;


        const dataItems: Array<IData> = dataInfo.reduce((prev: Array<IData>, item: Record<string, any>) => {

            const index = prev.findIndex(i => i.simpleName === item?.[groupInfo]);

            if (index >= 0) {
                prev[index].value = prev[index].value + 1;
            }
            else {
                prev.push({ simpleName: item?.[groupInfo], name: item?.[groupInfo], value: 1 })
            }




            return prev;



        }, [] as Array<IData>)

        if (dataItems?.length > 0) {
            dataItems.sort((a, b) => a.value < b.value ? 1 : a.value > b.value ? -1 : 0);
        }
        const total = dataItems?.reduce((prev, item) => {

            prev = prev + item?.value;
            return prev;

        }, 0)


        dataItems?.map(d => {
            d.percentage = ((d.value / total) * 100).toFixed(2);
            d.name = `${d.name} - ${d.value} - ${((d.value / total) * 100).toFixed(2)}%`;
        })



        setRenderData(dataItems);


    }

    useEffect(() => {
        console.log('started')
        renderDataInfo(group, data)

    }, [data, group])





    const option = {
        title: {
            text: title,
            subtext: subtitle,
            left: 'center'
        },
        tooltip: {
            trigger: 'item'
        },

        series: [
            {
                name: category,
                type: 'pie',
                radius: '50%',
                data: [
                    ...renderData
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };





    return <div className="container column" style={{ width: '100%' }}>





        <div className="container row-to-column row-to-column-start gap-sm pad" >
            <ReactEcharts option={option} style={{
                height: '50vh',
                width: '100%',
                maxWidth: '800px'
            }} />


            <div className="container column column-start max-400 overflow-hidden-height">
                <table className="tableRef" >
                    <thead>
                        <tr><th className="row-space-between">  Total</th><th>{renderData.length} </th><th></th></tr>

                        <tr><th className="row-space-between">  </th><th>QTD </th><th>% </th></tr>
                    </thead>
                    <tbody>
                        {renderData?.map(item => <tr key={`render-data-${group}-${item.name}`}><td>{item.simpleName}

                        </td><td>{item.value}</td><td>{item.percentage}%</td></tr>)}
                    </tbody>
                </table>
            </div>
        </div>


    </div >


}

export default Chart;